<template>


<div id="fuel_consumption" :class=div_classes >


<SelectRange 
:min="min"
:max="max"
classes="slider_green2red"
  step="0.1"
:default_value=displayed_value
v-model=displayed_value
>
<div slot="gauge" >
{{ displayValue }}
</div>       
</SelectRange> 

</div>
</template>

<script>

import settings from '../settings.js'
import conversions from '../conversions.js'
import SelectRange from './SelectRange.vue'

export default {
  components: {
    SelectRange
  },
  props: {
    value : {
      type: [Number, String],
      default: NaN
    },
    min : {
      type: [Number, String],
      default: 235.21 /  5
    },
    max : {
      type: [Number, String],
      default: 235.21 / 100
    },
    default_value : [Number, String],
    div_classes : String,
    name : String,
    items : {
      type: Array,
      default: function () {
        return []
      }
    }
  },
   computed: {
        displayed_value : {
            get(){
                return (isNaN(this.value) ? default_value : this.value)
            },set(val){
                this.$emit('input', val)
            }
        },
        
        // a computed getter
        marginLeft : function () {
          let max = 400;
          let percent = ((this.value) - (this.min))/((this.max) - (this.min))  ;
          
          return parseInt(max*percent) - 20
        },
        displayValue : function () {
              return this.displayUnit(this.value)
        }
    },
    methods : {
        displayUnit : function(val){
            let unit = this.settings('getFuelConsumptionUnit');
            switch(unit){
                case 'lp100km':
                    return parseFloat(val).toFixed(1) + " L/100KM"
                    
                case 'mpguk' :
                    // Uk imperial gallons, lol
                    return conversions['lp100km2mpg_uk'](val).toFixed(0) + " mpg"
                    
                default:
                    return conversions['lp100km2mpg_us'](val).toFixed(0) + " mpg"
            }
        },
        settings : function(fn, ...args){
            return settings[fn](...args);
        }
  }
}
</script>

<style >

.slider_green2red {
    -webkit-appearance: none;  /* Override default CSS styles */
    appearance: none;
    width: 100%; /* Full-width */
    height: 25px; /* Specified height */
    outline: none; /* Remove outline */
    
    border-radius: 10px;
    background: rgb(255,25,25); /* Old browsers */
    background: -moz-linear-gradient(right, rgba(255,25,25,1) 0%, rgba(252,255,91,1) 66%, rgba(185,206,162,1) 83%); /* FF3.6-15 */
    background: -webkit-linear-gradient(right, rgba(255,25,25,1) 0%,rgba(252,255,91,1) 66%,rgba(185,206,162,1) 83%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to left, rgba(255,25,25,1) 0%,rgba(252,255,91,1) 66%,rgba(185,206,162,1) 83%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    
    border: 1px solid #fff;

}

.slider_green2red::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    width: 25px; /* Set a specific slider handle width */
    height: 25px; /* Slider handle height */
    background: #666; /* Green background */
    cursor: pointer; /* Cursor on hover */
        border-radius: 1em;

}

.slider_green2red::-moz-range-thumb {
    width: 25px; /* Set a specific slider handle width */
    height: 25px; /* Slider handle height */
    background: #666; /* Green background */
    cursor: pointer; /* Cursor on hover */
    border-radius: 1em;
}

div#fuel_consumption {
    max-width: 400px;
}
 
</style>
